import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/services/api/api.service';
import { ProductsService } from 'src/app/core/services/products/products.service';

@Component({
  selector: 'app-device-details',
  templateUrl: './device-details.component.html',
  styleUrls: ['./device-details.component.css']
})
export class DeviceDetailsComponent implements OnInit {

  id:any;
  device:any;

  constructor(private _activatedRoute:ActivatedRoute, public sanitizer: DomSanitizer,private productService:ProductsService, private apiService:ApiService) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params) => {
      console.log(params);
      this.id = params.id;
      this.productService.getProductDetails(this.id).subscribe((resp: any) => {
        this.device = resp.data;      
      }, (err: any) => {
        console.log(err);
      });
    });
  }

}
